@if (!isSpecific() && isFooter()) {
    <hr class="specific-divider" />
}

<div>
    <div class="drawer-item-wrap">
        <div [id]="'nav-' + entity().id" class="drawer-item" [class.active]="isActive()" (click)="selectEntity()">
            <div class="drawer-item-content">
                <small
                    class="sp-icon icon-chevron-right"
                    style="display: block"
                    [style.rotate]="showChildren() ? '90deg' : '0deg'"
                >
                </small>

                <img [attr.src]="iconSrc()" alt="lpc-block-icon" />

                <div class="text-wrapper">
                    <div class="text-item">{{ blockName() | translate }}</div>
                    <div class="id-item" [title]="'id: ' + displayId()">id: {{ displayId() }}</div>
                </div>
            </div>
        </div>

        @let isDisabled = isActionRestricted() || isBlockRestricted();
        <div dropdown #dropdown="bs-dropdown" class="btn-group dropdown dropdown-options">
            <button
                dropdownToggle
                type="button"
                class="btn btn-action dropdown-toggle"
                aria-haspopup="true"
                aria-expanded="false"
            >
                <span class="sp-icon icon-ellipsis"></span>
            </button>

            <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu" aria-labelledby="button-basic">
                <li role="menuitem" [class.disabled]="isDisabled">
                    <a class="dropdown-item" (click)="copyBlock()">
                        <span class="sp-icon icon-copy"> </span>
                        {{ "duplicate" | translate }}
                    </a>
                </li>
                <li>
                    <hr />
                </li>
                <li role="menuitem" (click)="removeBlock()" [class.disabled]="isDisabled">
                    <a>
                        <span class="sp-icon icon-bin color-danger"></span>
                        {{ "delete" | translate }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>

@if (showChildren()) {
    <div class="drawer-item-children">
        @for (section of sections(); track $index; let i = $index) {
            @switch (entity().entitySubType) {
                @case ("specific") {
                    <web-navigation-specific-section-item
                        [parentEntity]="entity()"
                        [parentIndex]="index()"
                        [entity]="section"
                        [index]="i"
                        [selectedEntity]="selectedEntity()"
                    />
                }
                @case ("zero") {
                    <web-navigation-zero-section-item
                        [entity]="section"
                        [index]="i"
                        [selectedEntity]="selectedEntity()"
                    />
                }
                @default {
                    <web-navigation-section-item [entity]="section" [index]="i" [selectedEntity]="selectedEntity()" />
                }
            }
        }
    </div>
}

@if (isSpecific()) {
    <hr class="specific-divider" />
}
